// Shopify - Replace only the "Add to cart" prefix with "CUSTOMIZE NOW", keep the price part.
// Works across variant changes and dynamically re-rendered buttons.

(() => {
  const RE_FROM = /^\s*Add to cart(\s*[-–—]?\s*)(.*)$/i; // captures separator + trailing price/text
  const RE_SKIP = /^(Sold out|Pre.?order|Buy it now|Unavailable)/i;
  const LABEL = "CUSTOMIZE NOW";
  const SELECTOR = '#product-add-to-cart, .product-form__submit[name="add"], button[name="add"][type="submit"]';

  function rewrite(btn) {
    if (!btn) return;
    const txt = (btn.textContent || "").trim();
    if (RE_SKIP.test(txt)) return;

    const m = txt.match(RE_FROM);
    if (m) {
      const newTxt = (LABEL + (m[1] || "") + (m[2] || "")).trim();
      if (txt !== newTxt) {
        btn.textContent = newTxt;
        btn.setAttribute("aria-label", newTxt);
      }
    }
  }

  function findButtons() {
    return Array.from(document.querySelectorAll(SELECTOR));
  }

  const observed = new WeakSet();
  function observeButton(btn) {
    if (!btn || observed.has(btn)) return;
    const mo = new MutationObserver(() => rewrite(btn));
    mo.observe(btn, { childList: true, characterData: true, subtree: true });
    observed.add(btn);
  }

  function applyAll() {
    findButtons().forEach((btn) => {
      rewrite(btn);
      observeButton(btn);
    });
  }

  // Run once DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyAll, { once: true });
  } else {
    applyAll();
  }

  // Re-apply on common variant events
  ["variant:change", "variant:changed", "theme:variant:change"].forEach((ev) =>
    document.addEventListener(ev, applyAll, true)
  );

  // Fallback when the variant <select name="id"> changes
  document.addEventListener(
    "change",
    (e) => {
      if (e.target && (e.target.name === "id" || e.target.closest('form[action*="/cart/add"]'))) {
        applyAll();
      }
    },
    true
  );

  // Watch for newly inserted add-to-cart buttons (sticky bars, modals, etc.)
  const rootObs = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const n of m.addedNodes || []) {
        if (
          n.nodeType === 1 &&
          ((n.matches && n.matches(SELECTOR)) ||
            (n.querySelector && n.querySelector(SELECTOR)))
        ) {
          applyAll();
          return;
        }
      }
    }
  });
  rootObs.observe(document.documentElement, { childList: true, subtree: true });
})();
